<div class="loading-image-container">
  <div class="loading-image small"></div>
  <div class="loading-text">{{heading}}</div>
</div>